const footer = {
  props: {
    dynamicClass: "footer.dynamicLoading",
    vMenus: "footer .v-menu",
    marketTargeting: "footer .market-targeting",
    brands: "footer .brands",
    channelParam: "channel=app",
    classNameLogo: ".c-refooter__logo",
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-footer.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document,
      $breadcrumbFooter = baseFind.querySelector("footer .breadcrumb"),
      $breadcrumbHeader = baseFind.querySelector(":not(footer) .breadcrumb");

    document.querySelectorAll("footer").forEach(($footer) => {
      this.checkParamChannelInUrl($footer, this.props.channelParam);
    });

    if (!$breadcrumbFooter && !$breadcrumbHeader) {
      return;
    }

    if ($breadcrumbFooter) {
      $breadcrumbFooter.removeChild($breadcrumbFooter.children[0]);
      $breadcrumbHeader.children[0] && $breadcrumbFooter.appendChild($breadcrumbHeader.children[0].cloneNode(true));
    }
  },

  checkParamChannelInUrl: function (component, channelParam) {
    const url = window.location.href;

    if (url.includes(channelParam)) {
      component.querySelectorAll(this.props.vMenus)?.forEach(($menu) => {
        $menu.classList.add("hidden");
      });

      component.querySelectorAll(this.props.marketTargeting)?.forEach(($menu) => {
        $menu.classList.add("hidden");
      });

      component.querySelector(this.props.brands)?.classList.add("hidden");
      component.querySelector(this.props.classNameLogo)?.classList.add("hidden");
    }
  },
};

export default footer;
